<template>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <div v-for="(item, index) in data" :key="index">
            <el-form-item class="search-item" v-if="item.type === 'input'" :label="item.label" :prop="item.prop">
                <el-input v-model="formInline[item.prop]" :placeholder="item.plea" clearable />
            </el-form-item>
            <el-form-item v-else-if="item.type === 'select'" :label="item.label" :prop="item.prop">
                <el-select class="search-item" filterable v-model="formInline[item.prop]" :placeholder="item.plea" clearable>
                    <el-option v-for="key in item.props" :label="key.label" :value="key.value" :key="key" clearable></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="search-item" v-else-if="item.type === 'date'" :label="item.label" :prop="item.prop">
                <el-date-picker
                    v-model="formInline[item.prop]"
                    :placeholder="item.plea"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    clearable
                />
            </el-form-item>
        </div>
        <el-form-item>
            <el-button type="primary" @click="onSubmit">筛选</el-button>
        </el-form-item>
    </el-form>
</template>

<script setup>
import { ref, reactive, watch, onMounted, toRefs, onUnmounted } from 'vue'
/**
 * 该组件只是根据传入的配置项生成对应的筛选区域表单
 * 根据回调传递表格中的数据
 */
const props = defineProps({
    data: Array,
})
const data = ref(props.data)
const formInline = reactive({})
const emit = defineEmits('onSrarch')
onMounted(() => {
    init()
})
const init = async () => {
    data?.value?.map((item, index) => {
        formInline[item.prop] = item.value + ''
    })
}
const onSubmit = () => {
    emit('onSrarch', formInline)
}
</script>
<style lang="scss" scoped></style>
